export default __webpack_public_path__ + "static/media/dose_std.1d4dfa2b.npy";